import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class FreightUserActivity extends Component {
	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Freight/FreightUser/FreightUserBrowser")
	}

	render() {
		return (
			<Activity 
				name="FreightUser"
				RenderedComponent={this.RenderedComponent}
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(FreightUserActivity)